import { ICustomDrawerProps } from './CustomDrawer.def';

export const CustomDrawer = (props: ICustomDrawerProps) => {
  const { title, children, footer, closePopup } = props;

  const onOverlayClick = (event: React.MouseEvent) => {
    if (event.target !== event.currentTarget) {
      return;
    }
    event.preventDefault();
    closePopup?.();
  };

  return (
    <div className="property_overlay search_filters d-block" onClick={onOverlayClick}>
      <div className="property_window max-width-500px">
        <div className="pw_header d-flex mb-1 pl-4 align-items-center position-static">
          <div className="pt-4 mb-4">{title}</div>
          <div className="ml-auto btn_close_popup p-3" onClick={closePopup}>
            <img src="https://content.harstatic.com/media/icons/close_black.svg" />
          </div>
        </div>
        <div className='px-4'>{children}</div>
        {footer}
      </div>
    </div>
  );
};
